import React, { useState, useEffect } from 'react'
import sessionUtils from '../../utilities/SessionHandler'
import ModalComponent from '../../components/Private/ModalComponent'
import Navbar from '../../components/Private/Navbar'
import { useNavigate } from 'react-router-dom'

import fileService from '../../services/files'
import companyUserService from '../../services/companyUsers'
import companyService from '../../services/companies'
import businessRoleService from '../../services/businessroles'
import stateService from '../../services/states'
import cityService from '../../services/cities'

//TODO: Indicaciones de avatar

export default function MyProfile() {

    const navigateTo = useNavigate()

    const [callbackData, setCallbackData] = useState(null)
    const [showModal, setShowModal] = useState(false)
    const [modalTitle, setModalTitle] = useState('')
    const [modalBody, setModalBody] = useState('')

    const [stateList, setStateList] = useState([])
    const [cityList, setCityList] = useState([])
    const [branchList, setBranchList] = useState([])

    const [companyUser, setCompanyUser] = useState(null)
    const [companyUserRole, setCompanyUserRole] = useState(null)

    let credentials = sessionUtils.getParsedCredentials()

    const [userAvatar, setUserAvatar] = useState(null)
    const [companyAvatar, setCompanyAvatar] = useState(null)

    const [formData, setFormData] = useState({
        companyUserFullName: '',
        companyUserDNI: '',
        companyUserPhone: '',
        companyUserEmail: '',
        companyUserPassword: '',
        avatar_id: null,
        company_avatar_id: null
    })

    const [companyFormData, setCompanyFormData] = useState({
        state_id: 1,
        city_id: 1,
        companyName: '',
        companyDNI: '',
        companyAddress: '',
        companyManagerName: '',
        companyManagerPhone: '',
        companyManagerEmail: '',
        companyBranchName: '',
    })

    const [fileLoading, setFileLoading] = useState(false)
    const [companyFileLoading, setCompanyFileLoading] = useState(false)

    const [fileData, setFileData] = useState({
        file: ''
    })

    const [companyFileData, setCompanyFileData] = useState({
        file: ''
    })

    const handleStateListLoad = async () => {
        const result = await stateService.list();
        setStateList(result)
        setCompanyFormData({
            ...companyFormData,
            state_id: result[0].id
        })
    }

    const handleCityListLoad = async (state_id) => {
        const result = await cityService.byStates(state_id);
        setCityList(result)
    }

    const handleBranchListLoad = () => {
        const branchNames = [
            "CChC Nacional",
            "Arica",
            "Tarapacá",
            "Calama",
            "Antofagasta",
            "Atacama",
            "La Serena",
            "Valparaíso",
            "O'Higgins",
            "Maule",
            "Ñuble",
            "Concepción",
            "Los Ángeles",
            "Araucanía",
            "Valdivia",
            "Osorno",
            "Puerto Montt",
            "Coyhaique",
            "Magallanes"
        ]
        setBranchList(branchNames)
    }

    const handleCallbackOnHide = (data) => {
        navigateTo(data.destination)
    }

    const handleUserLoad = async () => {
        const result = await companyUserService.get(credentials.id)

        var processedResult = {
            ...result,
            company_avatar_id: result.company?.company_avatar_id
        }

        setCompanyUser(result)

        let loadedData = {
            ...processedResult,
            companyUserPassword: ''
        }

        if (processedResult?.avatar_id)
            handleFileImage(processedResult)

        if (processedResult?.company_avatar_id)
            handleCompanyFileImage(processedResult)

        setFormData(loadedData)
    }

    const handleCompanyLoad = async () => {

        const result = await companyService.get(credentials.company_id)
        setCompanyFormData({
            ...result,
        })
    }

    const handleRoleLoad = async () => {
        const result = await businessRoleService.get(credentials.businessRole_id)
        setCompanyUserRole(result)
    }

    const handleFieldChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        })
    }

    const handleCompanyFieldChange = (e) => {
        setCompanyFormData({
            ...companyFormData,
            [e.target.name]: e.target.value
        })
    }

    const handleFormSubmit = async (e) => {
        e.preventDefault()

        try {

            const result = await companyUserService.update(credentials.id, formData)

            if (result && result.status === 200) {

                const companyResult = await companyService.update(credentials.company_id, companyFormData)

                if (companyResult && companyResult.status === 200) {
                    setModalTitle('Éxito')
                    setModalBody('Se ha actualizado su perfil correctamente')
                    setShowModal(true)

                    const newUser = await companyUserService.get(credentials.id)
                    sessionUtils.setCredentials(
                        btoa(JSON.stringify(newUser))
                    )

                    setCallbackData({ destination: "/home" })
                } else {

                    throw new Error(companyResult)

                }

            } else {

                throw new Error(result)

            }
        } catch (error) {
            setModalTitle('Error')
            setModalBody('Error al actualizar el perfil: ' + JSON.stringify(error.data.messages.error))
            setShowModal(true)
        }

    }

    const handleFileUpload = async (avatar) => {
        setFileLoading(true)
        setFileData({
            file: avatar
        })
        const fileResult = await fileService.create({
            file: avatar,
            type: 'avatar'
        })
        if (fileResult) {
            console.log(fileResult)
            await companyUserService.patch(credentials.id, {
                avatar_id: fileResult.id
            })
        }
        handleUserLoad()
        handleCompanyLoad()
        setFileLoading(false)
    }

    const handleCompanyFileUpload = async (avatar) => {
        setCompanyFileLoading(true)
        setCompanyFileData({
            file: avatar
        })
        const fileResult = await fileService.create({
            file: avatar,
            type: 'avatar'
        })

        if (fileResult) {
            console.log(fileResult)
            await companyUserService.patch(credentials.id, {
                company_avatar_id: fileResult.id
            })
        }
        handleUserLoad()
        handleCompanyLoad()
        setCompanyFileLoading(false)
    }

    const handleFileDelete = async () => {
        setFileLoading(true)
        await companyUserService.patch(credentials.id, {
            avatar_id: null
        })
        handleUserLoad()
        handleCompanyLoad()
        setFileLoading(false)
    }

    const handleCompanyFileDelete = async () => {
        setCompanyFileLoading(true)
        await companyUserService.patch(credentials.id, {
            company_avatar_id: 0
        })
        handleUserLoad()
        handleCompanyLoad()
        setCompanyFileLoading(false)
    }

    const handleFileImage = async (item) => {
        const fileResult = await fileService.get(item.avatar_id)
        if (!fileResult || !fileResult.fileBase64) return alert(
            fileResult.fileErrorMessage
        )
        const linkSource = `data:${fileResult.fileMimeType};base64,${fileResult.fileBase64}`
        setUserAvatar(linkSource)
    }

    const handleCompanyFileImage = async (item) => {
        const fileResult = await fileService.get(item.company.company_avatar_id)
        if (!fileResult || !fileResult.fileBase64) return alert(
            fileResult.fileErrorMessage
        )
        const linkSource = `data:${fileResult.fileMimeType};base64,${fileResult.fileBase64}`
        setCompanyAvatar(linkSource)
    }

    useEffect(() => {
        handleUserLoad()
        handleCompanyLoad()
        handleStateListLoad()
        handleRoleLoad()
    }, [])

    useEffect(() => {
        if (companyFormData.state_id !== '' && companyFormData.state_id !== undefined) {
            handleCityListLoad(companyFormData.state_id)
            handleBranchListLoad()
        }
    }, [companyFormData.state_id]);

    return (
        <>
            <Navbar companyUser />
            <main className="theme-light">
                <div className="container">
                    <div className="row mb-4">
                        <div className='d-flex justify-content-start align-item-center'>
                            <div className="btn-group me-3">
                                <button className="btn btn-outline-primary px-3 py-2" type="button" onClick={
                                    () => navigateTo('/home')
                                }>
                                    <i className="fas fa-arrow-left"></i>
                                </button>
                            </div>
                            <h3 className="page-title fw-bold mb-lg-0 mb-0">
                                Mi Perfil
                            </h3>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <div className="card bg-fondo-suave">
                                <div className="card-body p-4">
                                    <form action="">
                                        <div className="row">
                                            <div className="col-md-6 px-md-4 px-0">
                                                <div className="form-outline mb-4">
                                                    <label className="form-label" htmlFor="">Nombre Completo</label>
                                                    <input
                                                        type="text"
                                                        name="companyUserFullName"
                                                        className="form-control form-control-lg rounded-pill"
                                                        placeholder="Ingrese su nombre completo"
                                                        value={formData.companyUserFullName}
                                                        onChange={handleFieldChange}
                                                    />
                                                </div>
                                                <div className="form-outline mb-4">
                                                    <label className="form-label" htmlFor="">RUT</label>
                                                    <input
                                                        type="text"
                                                        name="companyUserDNI"
                                                        className="form-control form-control-lg rounded-pill"
                                                        placeholder="Ingrese su RUT"
                                                        value={formData.companyUserDNI}
                                                        onChange={handleFieldChange}
                                                    />
                                                </div>
                                                <div className="form-outline mb-4">
                                                    <label className="form-label" htmlFor="">Contraseña</label>
                                                    <input
                                                        autoComplete="off"
                                                        type="password"
                                                        name="companyUserPassword"
                                                        className="form-control form-control-lg rounded-pill"
                                                        placeholder="(Ingrese una contraseña nueva)"
                                                        value={formData.companyUserPassword}
                                                        onChange={handleFieldChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 px-md-4 px-0">
                                                <div className="form-outline mb-4">
                                                    <label className="form-label" htmlFor="">Teléfono</label>
                                                    <input
                                                        type="text"
                                                        name="companyUserPhone"
                                                        className="form-control form-control-lg rounded-pill"
                                                        placeholder="Teléfono"
                                                        value={formData.companyUserPhone}
                                                        onChange={handleFieldChange}
                                                    />
                                                </div>
                                                <div className="form-outline mb-4">
                                                    <label className="form-label" htmlFor="">Email</label>
                                                    <input
                                                        type="text"
                                                        name="companyUserEmail"
                                                        className="form-control form-control-lg rounded-pill"
                                                        placeholder="Ingrese su email"
                                                        value={formData.companyUserEmail}
                                                        onChange={handleFieldChange}
                                                    />
                                                </div>
                                                {
                                                    formData && (

                                                        formData?.avatar_id === null
                                                            ?
                                                            <div className='form-outline mb-4'>
                                                                <div className='d-flex justify-content-center align-items-center'>
                                                                    {
                                                                        fileLoading ? (
                                                                            <div className="spinner-border my-4" role="status">
                                                                                <span className="visually-hidden">Loading...</span>
                                                                            </div>
                                                                        ) : (
                                                                            <div className="row">
                                                                                <div className='col-md-12'>
                                                                                    <label htmlFor='file' className='form-label'>Imagen de Usuario</label>
                                                                                    <input
                                                                                        name='file'
                                                                                        id='file'
                                                                                        type='file'
                                                                                        className='form-control'
                                                                                        placeholder='File'
                                                                                        accept='.png, .jpg, .jpeg'
                                                                                        onChange={
                                                                                            (e) => {
                                                                                                handleFileUpload(e.target.files[0])
                                                                                            }
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                                <div className='col-md-12 text-end text-info mt-2'>
                                                                                    <p>Suba una imagen con tamaño no superior a 2MB</p>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    }
                                                                </div>
                                                            </div>
                                                            :
                                                            <div className='form-outline mb-4'>
                                                                <div className='row'>
                                                                    <div
                                                                        className='d-flex justify-content-center align-items-center'
                                                                        style={{
                                                                            maxWidth: '100%',
                                                                        }}>
                                                                        {
                                                                            userAvatar ? (
                                                                                <>
                                                                                    <div className='row'>
                                                                                        <div className='col-md-12 text-center'>
                                                                                            <label htmlFor='file' className='form-label'>Imagen de Usuario</label>
                                                                                        </div>
                                                                                        <div className='col-md-12 text-center'>
                                                                                            <img
                                                                                                src={userAvatar}
                                                                                                alt='Avatar'
                                                                                                className='img-fluid mb-4'
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                </>
                                                                            ) : (
                                                                                <div className="spinner-border my-4" role="status">
                                                                                    <span className="visually-hidden">Loading...</span>
                                                                                </div>
                                                                            )
                                                                        }

                                                                    </div>
                                                                </div>
                                                                <div className='row'>
                                                                    <div
                                                                        className='d-flex justify-content-center align-items-center'
                                                                        style={{
                                                                            maxWidth: '100%',
                                                                        }}>
                                                                        <button
                                                                            type='button'
                                                                            className='btn btn-outline-danger mt-2'
                                                                            onClick={handleFileDelete}
                                                                        >
                                                                            Eliminar
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                    )
                                                }
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-lg-12'>
                                                <hr />
                                                {
                                                    formData && (

                                                        formData?.company_avatar_id === null && credentials?.businessRole_id === "1"
                                                            ?
                                                            <div className='form-outline mb-4'>
                                                                <div className='d-flex justify-content-center align-items-center'>
                                                                    {
                                                                        companyFileLoading ? (
                                                                            <div className="spinner-border my-4" role="status">
                                                                                <span className="visually-hidden">Loading...</span>
                                                                            </div>
                                                                        ) : (
                                                                            <div className="row">
                                                                                <div className='col-md-12'>
                                                                                    <label htmlFor='file' className='form-label'>Logo Empresa</label>
                                                                                    <input
                                                                                        name='file'
                                                                                        id='file2'
                                                                                        type='file'
                                                                                        className='form-control'
                                                                                        placeholder='File'
                                                                                        accept='.png, .jpg, .jpeg'
                                                                                        onChange={
                                                                                            (e) => {
                                                                                                handleCompanyFileUpload(e.target.files[0])
                                                                                            }
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                                <div className='col-md-12 text-end text-info mt-2'>
                                                                                    <p>Suba una imagen con tamaño no superior a 2MB</p>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    }
                                                                </div>
                                                            </div>
                                                            :
                                                            <div className='form-outline mb-4'>
                                                                <div className='row'>
                                                                    <div
                                                                        className='d-flex justify-content-center align-items-center'
                                                                        style={{
                                                                            maxWidth: '100%',
                                                                        }}>
                                                                        {
                                                                            companyAvatar ? (
                                                                                <>
                                                                                    <div className='row'>
                                                                                        <div className='col-md-12 text-center'>
                                                                                            <label htmlFor='file' className='form-label'>Logo de Empresa</label>
                                                                                        </div>
                                                                                        <div className='col-md-12 text-center'>
                                                                                            <img
                                                                                                src={companyAvatar}
                                                                                                alt='Avatar'
                                                                                                className='img-fluid mb-4'
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                </>
                                                                            ) : (
                                                                                <div className="spinner-border my-4" role="status">
                                                                                    <span className="visually-hidden">Loading...</span>
                                                                                </div>
                                                                            )
                                                                        }

                                                                    </div>
                                                                </div>
                                                                <div className='row'>
                                                                    <div
                                                                        className='d-flex justify-content-center align-items-center'
                                                                        style={{
                                                                            maxWidth: '100%',
                                                                        }}>
                                                                        <button
                                                                            type='button'
                                                                            className='btn btn-outline-danger mt-2'
                                                                            onClick={handleCompanyFileDelete}
                                                                        >
                                                                            Eliminar
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                    )
                                                }
                                                <hr />
                                                {
                                                    formData && (
                                                        <div className="row">
                                                            <div className="col-md-6 px-md-4 px-0">
                                                                <div className="form-outline mb-4">
                                                                    <label className="form-label" htmlFor="">Nombre de la Empresa</label>
                                                                    <input
                                                                        type="text"
                                                                        name="companyName"
                                                                        className="form-control form-control-lg rounded-pill"
                                                                        placeholder="Ingrese el nombre de la empresa"
                                                                        value={companyFormData.companyName}
                                                                        onChange={handleCompanyFieldChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6 px-md-4 px-0">
                                                                <div className="form-outline mb-4">
                                                                    <label className="form-label" htmlFor="">RUT Empresa</label>
                                                                    <input
                                                                        type="text"
                                                                        name="companyDNI"
                                                                        className="form-control form-control-lg rounded-pill"
                                                                        placeholder="Ingrese el RUT de la empresa"
                                                                        value={companyFormData.companyDNI}
                                                                        onChange={handleCompanyFieldChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6 px-md-4 px-0">
                                                                {
                                                                    stateList !== '' && stateList.length > 0 && <div className="form-outline mb-4">
                                                                        <label
                                                                            className="form-label"
                                                                            htmlFor="state_id"
                                                                        >
                                                                            Región
                                                                        </label>
                                                                        <select
                                                                            id="state_id"
                                                                            className="form-control form-control-lg rounded-pill"
                                                                            name="state_id"
                                                                            onChange={handleCompanyFieldChange}
                                                                            value={companyFormData.state_id}
                                                                        >
                                                                            {stateList.map((state) => (
                                                                                <option
                                                                                    key={state.id}
                                                                                    value={state.id}
                                                                                >
                                                                                    {state.stateName}
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                    </div>
                                                                }
                                                            </div>
                                                            <div className="col-md-6 px-md-4 px-0">
                                                                {
                                                                    cityList != '' && cityList.length > 0 && <div className="form-outline mb-4">
                                                                        <label
                                                                            className="form-label"
                                                                            htmlFor="city_id"
                                                                        >
                                                                            Comuna
                                                                        </label>
                                                                        <select
                                                                            id="city_id"
                                                                            className="form-control form-control-lg rounded-pill"
                                                                            name="city_id"
                                                                            onChange={handleCompanyFieldChange}
                                                                            value={companyFormData.city_id}
                                                                        >
                                                                            {cityList.map((city) => (
                                                                                <option
                                                                                    key={city.id}
                                                                                    value={city.id}
                                                                                >
                                                                                    {city.cityName}
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                    </div>
                                                                }
                                                            </div>
                                                            <div className="col-md-6 px-md-4 px-0">
                                                                <div className="form-outline mb-4">
                                                                    <label className="form-label" htmlFor="">Dirección</label>
                                                                    <input
                                                                        type="text"
                                                                        name="companyAddress"
                                                                        className="form-control form-control-lg rounded-pill"
                                                                        placeholder="Ingrese la dirección de la empresa"
                                                                        value={companyFormData.companyAddress}
                                                                        onChange={handleCompanyFieldChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                                <hr />
                                                {
                                                    formData && (
                                                        <div className="row">
                                                            <div className="col-md-6 px-md-4 px-0">
                                                                <div className="form-outline mb-4">
                                                                    <label className="form-label" htmlFor="">Nombre del Encargado</label>
                                                                    <input
                                                                        type="text"
                                                                        name="companyManagerName"
                                                                        className="form-control form-control-lg rounded-pill"
                                                                        placeholder="Ingrese el nombre de la empresa"
                                                                        value={companyFormData.companyManagerName}
                                                                        onChange={handleCompanyFieldChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6 px-md-4 px-0">
                                                                <div className="form-outline mb-4">
                                                                    <label className="form-label" htmlFor="">Teléfono Encargado</label>
                                                                    <input
                                                                        type="text"
                                                                        name="companyManagerPhone"
                                                                        className="form-control form-control-lg rounded-pill"
                                                                        placeholder="Ingrese el teléfono del encargado"
                                                                        value={companyFormData.companyManagerPhone}
                                                                        onChange={handleCompanyFieldChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6 px-md-4 px-0">
                                                                <div className="form-outline mb-4">
                                                                    <label className="form-label" htmlFor="">Email Encargado</label>
                                                                    <input
                                                                        type="text"
                                                                        name="companyManagerEmail"
                                                                        className="form-control form-control-lg rounded-pill"
                                                                        placeholder="Ingrese el email del encargado"
                                                                        value={companyFormData.companyManagerEmail}
                                                                        onChange={handleCompanyFieldChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                                <hr />
                                                {
                                                    formData && (
                                                        <div className="row">
                                                            <div className="col-md-6 px-md-4 px-0">
                                                                <div className="form-outline mb-4">
                                                                    <label className="form-label" htmlFor="">Nombre del Gerente General</label>
                                                                    <input
                                                                        type="text"
                                                                        name="companyGeneralManagerName"
                                                                        className="form-control form-control-lg rounded-pill"
                                                                        placeholder="Ingrese el nombre de la gerente general"
                                                                        value={companyFormData.companyGeneralManagerName}
                                                                        onChange={handleCompanyFieldChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6 px-md-4 px-0">
                                                                <div className="form-outline mb-4">
                                                                    <label className="form-label" htmlFor="">Teléfono Gerente General</label>
                                                                    <input
                                                                        type="text"
                                                                        name="companyGeneralManagerPhone"
                                                                        className="form-control form-control-lg rounded-pill"
                                                                        placeholder="Ingrese el teléfono del gerente general"
                                                                        value={companyFormData.companyGeneralManagerPhone}
                                                                        onChange={handleCompanyFieldChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6 px-md-4 px-0">
                                                                <div className="form-outline mb-4">
                                                                    <label className="form-label" htmlFor="">Email Gerente General</label>
                                                                    <input
                                                                        type="text"
                                                                        name="companyGeneralManagerEmail"
                                                                        className="form-control form-control-lg rounded-pill"
                                                                        placeholder="Ingrese el email del gerente general"
                                                                        value={companyFormData.companyGeneralManagerEmail}
                                                                        onChange={handleCompanyFieldChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                            {
                                                                branchList != '' && branchList.length > 0 && <div className='col-md-6 px-md-4 px-0'>
                                                                    <div className="form-outline mb-4">
                                                                        <label
                                                                            className="form-label"
                                                                            htmlFor="companyBranchName"
                                                                        >
                                                                            Sede de Cámara Chilena de Comercio
                                                                        </label>
                                                                        <select
                                                                            id="companyBranchName"
                                                                            className="form-control form-control-lg rounded-pill"
                                                                            name="companyBranchName"
                                                                            onChange={handleCompanyFieldChange}
                                                                            value={companyFormData.companyBranchName}
                                                                            disabled
                                                                        >
                                                                            {branchList.map((branch) => (
                                                                                <option
                                                                                    key={branch}
                                                                                    value={branch}
                                                                                >
                                                                                    {branch}
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        </div>

                                        <div className="d-flex justify-content-end">
                                            <button
                                                className="btn btn-primary px-3 py-2"
                                                type="button"
                                                onClick={handleFormSubmit}
                                            >
                                                Guardar
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <ModalComponent
                id='alertModal'
                title={modalTitle}
                show={showModal}
                setShow={setShowModal}
                callbackOnHide={handleCallbackOnHide}
                callbackData={callbackData}
            >
                <p>
                    {modalBody}
                </p>
                <div className='d-flex justify-content-end mt-4'>
                    <button
                        type='button'
                        className='btn btn-secondary'
                        onClick={() => {
                            setShowModal(false)
                        }}
                    >
                        Ok
                    </button>
                </div>
            </ModalComponent>
        </>
    )
}
